var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.video.enableLiveChat && _vm.liveChatUrl
      ? _c("div", { ref: "liveChat", staticClass: "live-chat" }, [
          _c("iframe", {
            attrs: {
              src: _vm.liveChatUrl,
              frameborder: "0",
              allow:
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: "",
              referrerpolicy: "strict-origin-when-cross-origin"
            }
          })
        ])
      : _c("div", { ref: "playList", staticClass: "play-list" }, [
          _c("div", { staticClass: "category-title" }, [
            _c("div", {
              staticClass: "channel-avatar",
              style: { backgroundImage: "url(" + _vm.category.iconUrl + ")" }
            }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.category.name))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.categoryVideos, function(video) {
              return _c(
                "div",
                {
                  key: video.id,
                  ref: video.id === _vm.videoId ? "activeVideo" : null,
                  refInFor: true,
                  staticClass: "play-list-card",
                  class: { active: video.id === _vm.videoId },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.$emit("handleClickViewVideo", video)
                    }
                  }
                },
                [
                  _c("div", { staticStyle: { position: "relative" } }, [
                    video.isTargetPremium
                      ? _c("div", { staticClass: "premium-badge" }, [
                          _c("i", {
                            staticClass: "fa fa-diamond",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v("\n            プレミアム\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBasicPlan &&
                    video.isTargetPremium &&
                    video.isPurchased
                      ? _c("div", { staticClass: "purchased-badge" }, [
                          _c("i", {
                            staticClass: "fa fa-check",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v("\n            購入済み\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: video.thumbnail,
                        alt: video.title,
                        loading: "lazy"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "play-list-info" }, [
                    _c("div", { staticClass: "play-list-title" }, [
                      _vm._v(_vm._s(video.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flexbox gap-10 text-gray" }, [
                      _c("span", [_vm._v(" " + _vm._s(video.createDate))]),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", {
                          staticClass: "fa fa-thumbs-up",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(video.likes) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", {
                          staticClass: "fa fa-comments-o",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(video.comments) +
                            "\n            "
                        )
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]),
    _vm._v(" "),
    _c("div", { ref: "otherList", staticClass: "other-list" }, [
      _c("div", { staticClass: "other-list-header" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.atStart,
                expression: "atStart"
              }
            ],
            staticClass: "chip-scroll-button",
            on: {
              click: function($event) {
                _vm.scrollChips(-150)
              }
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-chevron-left",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "chipScroll", staticClass: "chip-scroll" },
          [
            _c(
              "button",
              {
                staticClass: "chip",
                class: { active: _vm.selectedCategory === "TOP" },
                on: {
                  click: function($event) {
                    _vm.handleChangeCategory("TOP")
                  }
                }
              },
              [_vm._v("\n          TOP\n        ")]
            ),
            _vm._v(" "),
            _vm._l(_vm.categoriesOther, function(c) {
              return _c(
                "button",
                {
                  key: c.id,
                  staticClass: "chip",
                  class: { active: _vm.selectedCategory === c.id },
                  on: {
                    click: function($event) {
                      _vm.handleChangeCategory(c.id)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(c.name) + "\n        ")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.atEnd,
                expression: "atEnd"
              }
            ],
            staticClass: "chip-scroll-button",
            on: {
              click: function($event) {
                _vm.scrollChips(150)
              }
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-chevron-right",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "video-list" },
        _vm._l(_vm.categoryVideoOthers, function(video) {
          return _c(
            "div",
            {
              key: video.id,
              staticClass: "video-item",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.$emit("handleClickViewVideo", video)
                }
              }
            },
            [
              _c("div", { staticClass: "thumbnail-wrapper" }, [
                video.isTargetPremium
                  ? _c("div", { staticClass: "premium-badge" }, [
                      _c("i", {
                        staticClass: "fa fa-diamond",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("\n            プレミアム\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                video.isTargetPremium && video.isPurchased
                  ? _c("div", { staticClass: "purchased-badge" }, [
                      _c("i", {
                        staticClass: "fa fa-check",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("\n            購入済み\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: video.thumbnail,
                    alt: video.title,
                    loading: "lazy"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "video-meta" }, [
                _c("div", { staticClass: "video-title" }, [
                  _vm._v(_vm._s(video.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flexbox gap-10 text-gray" }, [
                  _c("span", [_vm._v(" " + _vm._s(video.createDate))]),
                  _vm._v(" "),
                  _c("span", [
                    _c("i", {
                      staticClass: "fa fa-thumbs-up",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(
                      "\n              " +
                        _vm._s(video.likes) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _c("i", {
                      staticClass: "fa fa-comments-o",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(
                      "\n              " +
                        _vm._s(video.comments) +
                        "\n            "
                    )
                  ])
                ])
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7913a902", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7913a902","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/components/RelatedVideos.vue
// module id = null
// module chunks = 